import { render, staticRenderFns } from "./MessengerGroup.vue?vue&type=template&id=29c2674a&scoped=true&"
import script from "./MessengerGroup.vue?vue&type=script&lang=js&"
export * from "./MessengerGroup.vue?vue&type=script&lang=js&"
import style0 from "./MessengerGroup.vue?vue&type=style&index=0&id=29c2674a&scoped=true&lang=scss&"
import style1 from "./MessengerGroup.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c2674a",
  null
  
)

export default component.exports